export default "__VITE_ASSET__BdpxeNxF__"